import React from 'react';
import { useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import LoaderMessage from './LoaderMessage';
import IntroMessages from './IntroMessages';
import { useChatActions } from '../../../../../hooks/useChatActions';
import { useNavigate } from 'react-router-dom';

const ChatMessages = () => {
  const messages = useSelector((state) => state.messages);
  const isLoading = useSelector((state) => state.isLoading);
  const { handleCopyRequest, handleAutofixRequest, handleHighlightPath , handleRunCheckers, handleGoToModelDiagram} = useChatActions();
  const navigate = useNavigate();

  // Create a ref to the bottom of the messages container
  const bottomRef = useRef(null);

  useEffect(() => {
    // If any of the loading states are true, scroll the bottomRef into view smoothly
    if (isLoading.assistant || isLoading.user || isLoading.checkerManager) {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [isLoading]);

  useEffect(() => {
    // Scroll to bottom when a new message is added
    if (messages.length > 0) {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <div className="messages-container">
      <div ref={bottomRef} /> {/* 👈 This scrolls into view */}
      {isLoading.assistant && <LoaderMessage type="assistant" />}
      {isLoading.user && <LoaderMessage type="user" />}
      {isLoading.checkerManager && <LoaderMessage type="checkerManager" />}

      {messages.map((message, index) => (
        <div
          key={index}
          className={`message ${message.sender}`}
          dangerouslySetInnerHTML={{ __html: message.content }}
          onClick={async (e) => {
            if (e.target.classList.contains('consent-here')) navigate('/consent');
            if (e.target.classList.contains('copy-me')) handleCopyRequest(e);
            if (e.target.classList.contains('autofix-me')) await handleAutofixRequest(e);
            if (e.target.classList.contains('highlight-path')) await handleHighlightPath(e);
            if (e.target.classList.contains('check-me')) await handleRunCheckers();
            if (e.target.classList.contains('go-to-model-diagram')) await handleGoToModelDiagram(e);
          }}
        />
      ))}
      <IntroMessages />
    </div>
  );
};

export default ChatMessages;
